import { render, staticRenderFns } from "./HoverMenu.vue?vue&type=template&id=0b7162b7&scoped=true&"
import script from "./HoverMenu.vue?vue&type=script&lang=js&"
export * from "./HoverMenu.vue?vue&type=script&lang=js&"
import style0 from "./HoverMenu.vue?vue&type=style&index=0&id=0b7162b7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b7162b7",
  null
  
)

export default component.exports